<template>
<div style="margin: 0 40px;">
  <el-form size="small" style="margin-right: 30px" :model="nurseForm" :rules="nurseRules" ref="nurseForm" label-width="140px" class="demo-ruleForm old-person">
    <el-form-item label="卫生情况：" prop="">
      <el-checkbox-group v-model="nurseForm.hygiene">
        <el-checkbox v-for="item in hygieneArr" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="长者服务：" prop="">
      <el-checkbox-group v-model="nurseForm.service">
        <el-checkbox v-for="item in serviceArr" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="饮食及用药：" prop="">
      <el-checkbox-group v-model="nurseForm.dietMedicine">
        <el-checkbox v-for="item in medicineArr" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditUnit('nurseForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {updateelderly} from '../../../api/yanglaoyuan'

export default {
  name: 'nursePlan',
  props: {
    nurseObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      oldPersonRow: '',
      entityelderlyservice: '',
      hygieneArr: [
        {id: 1, name: '房间卫生'},
        {id: 2, name: '洗被'},
        {id: 3, name: '铺床'},
        {id: 4, name: '衣物整理'},
        {id: 5, name: '垃圾清理'}
      ],
      serviceArr: [
        {id: 1, name: '精神状态'},
        {id: 2, name: '更换衣裤'},
        {id: 3, name: '清洗衣物'},
        {id: 4, name: '送入开水'},
        {id: 5, name: '洗 头'},
        {id: 6, name: '洗 浴'},
        {id: 7, name: '修剪指甲'},
        {id: 8, name: '理 发'},
        {id: 9, name: '剃 须'}
      ],
      medicineArr: [
        {id: 1, name: '送 餐'},
        {id: 2, name: '协助用餐'},
        {id: 3, name: '用 药'}
      ],
      nurseForm: {
        id: '',
        extra_info: {},
        hygiene: [],
        service: [],
        dietMedicine: []
      },
      nurseRules: {
        name: [
          {required: true, message: '请输入', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.entityelderlyservice = this.nurseObj.entityelderlyservice
    this.oldPersonRow = this.nurseObj.oldPersonRow
    this.getStartNurse()
  },
  methods: {
    getStartNurse () {
      if (this.oldPersonRow === '' || this.oldPersonRow.id === 0) {
        this.$message({
          message: '请先新增老人基本信息。',
          type: 'warning'
        })
        return
      }
      let info = null
      if (this.oldPersonRow.extra_info && this.oldPersonRow.extra_info !== '') {
        info = JSON.parse(this.oldPersonRow.extra_info)
      }
      this.nurseForm = this.commonType.getOldPersonForm(this.oldPersonRow, info)
    },
    closeAddEdit () {
      this.$emit('changeEndNurse', {type: 'close'})
    },
    submitAddEditUnit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.commonType.getJsonInfo(this.nurseForm)
          updateelderly(data).then(res => {
            let obj = {
              type: 'isBtnNurse',
              nurseForm: this.nurseForm,
              extra_info: data.extra_info
            }
            this.$emit('changeEndNurse', obj)
            this.$notify({title: '成功', message: '成功编辑老人病史', type: 'success', duration: 2000})
          }).catch(() => {})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/nursePlan.vue